import React from "react";
import classNames from "classnames";
import { Link } from "react-router-dom";
import Image from "../../elements/Image";
import logo from "./../../../assets/icons/Light.svg";

const Logo = ({ className, height, width, ...props }) => {
  const classes = classNames("brand", className);

  return (
    <div {...props} className={classes} style={{ zIndex: 100 }}>
      <h1 className="m-0 ml-5 mr-5">
        <Link to="/">
          <Image
            className={"logo"}
            src={logo}
            width={width ? width : 74}
            height={height ? height : 74}
          />
        </Link>
      </h1>
    </div>
  );
};

export default Logo;
